function DealButton({ href, className, children }) {
  return (
      <a href={href} className={`deal-button ${className || ''}`}>{children}</a>
  );
}

function DealItem({ type, label, title, text, buttons }) {
  return (
      <div className={`deal-wrapper ${type.toLowerCase()}`}>
        <div className="deal-content">
          <div className="label">
            {label}
          </div>
          <div className="title">
            {title}
          </div>
          <div className="text">
            {text}
          </div>
          <div className="buttons-container">
            {buttons.map((button, index) => (
                <DealButton key={index} href={button.href} className={button.className}>
                  {button.text}
                </DealButton>
            ))}
          </div>
        </div>
      </div>
  );
}

export default DealItem;